import { useQueryClient } from '@tanstack/react-query';
import { useCreateCardBalances, useGetCardBalances } from '@/generated/hooks';
import { queryKeys } from '@/generated/hooks/query-keys';
import type { CardBalancesSaveInput } from '@/types/card-balances.types';

/** Latest prepaid/bonus values for one card and the append-only save command. */
export function useCardBalances(merchantId: number, cardId: string) {
  const queryClient = useQueryClient();
  const query = useGetCardBalances({ merchantId, cardId }, { retry: false });
  const mutation = useCreateCardBalances();

  const save = async (input: CardBalancesSaveInput) => {
    const saved = await mutation.mutateAsync({ merchantId, cardId, data: input });
    queryClient.setQueryData(queryKeys.merchantmembers.getCardBalances(merchantId, cardId), saved);
    return saved;
  };

  return { balances: query.data, isError: query.isError, isLoading: query.isLoading, isSaving: mutation.isPending, save };
}
